import { IEntity } from '@/base/core/iEntity';
export class FilterModel implements IEntity {
    currentSiteId!: any;
    originalUrl!: any;
    forms!: any;
    postedField!: any;
}